import React from 'react';

const EtapaDosLineas = (props) => {
  const descEtapa = props.descEtapa;

  let arrayEtapa = [];
  if (descEtapa !== undefined && descEtapa !== null) {
    arrayEtapa = String(descEtapa).split(' - ');
  }

  return (
    <React.Fragment>
      {arrayEtapa.length > 0 && arrayEtapa[0]}
      {arrayEtapa.length > 1 && <br />}
      {arrayEtapa.length > 1 && arrayEtapa[1]}
    </React.Fragment>
  );
};

export default EtapaDosLineas;
